import { Component, Vue } from "vue-property-decorator";
import Simple from './Simple'
import { TenantBizFieldServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import './bill.less'
import { deepClone } from '@/utils'

const tenantBizField = new TenantBizFieldServiceProxy()
@Component({
  name: 'bill-plan',
  components: {
    Simple
  }
})
export default class BillPlan extends Vue {
  bizCodeList = []
  tags = []
  dataType = ''
  dataId = ''
  dataName = ''
  notificationShow = false
  isEdit = false

  loadTable(value) {
    this.tags = []
    this.notificationShow = false
    this.bizCodeList = value.bizCode.split(",")
    if(value.dataId === ''){
      tenantBizField.getTenantBizDataTypeList(this.bizCodeList[0]).then(res => {
        if(res && res.length > 0 ){
          this.select(res[0].bizDataId)
          this.dataName = res[0].bizDataName
          let temp = deepClone(res)
          temp.map(item=>{
            item.key = 'page_plan_type_' + item.bizDataId
          })
          this.tags = temp
          console.log(11, this.tags)
        } else {
          this.select(undefined)
        }
      })
    }
  }

  handleTypeChange(value) {
    let a = this.dataType
    this.dataType = value
    const ok: any = this.$t('ok')
    const cancel: any = this.$t('cancel')
    if(this.isEdit){
      this.$confirm({
        title: this.$t('page_bill_settings_has_edit_content'),
        content: this.$t('page_bill_settings_switch_type'),
        okText: ok,
        okType: 'danger',
        cancelText: cancel,
        onOk: () => {
          this.select(value)
        },
        onCancel: () => {
          this.dataType = a
        },
      });
    } else {
      this.select(value)
    }
  }

  select(value) {
    this.dataType = value
    this.dataId = value
    if(this.tags && this.tags.length){
      const data = this.tags.find(res => res.bizDataId === value)
      if(data){
        this.dataName = data.bizDataName
      }
    }
  }

  render() {
    return (
      <blank-view mainStyle={{ 'background': "transparent", 'box-shadow': "none"}}>
        <div slot={'action'}>
          {(this.tags.length > 0) ?
            <a-select value={this.dataType} style="width: 220px;" showSearch onChange={e => this.handleTypeChange(e)}>
              {
                this.tags.map(item => {
                  return <a-select-option key={item.bizDataId}>{(item.bizDataId > 0 && item.bizDataId < 8) ? this.$t(item.key) : item.bizDataName}</a-select-option>
                })
              }
            </a-select> : null
          }
        </div>
        <div>
          { this.bizCodeList.map(item => {
            return <Simple
                      bizCode={item}
                      dataId={this.dataId}
                      dataName={this.dataName}
                      onEdit={() =>{this.isEdit = true}}
                      onCloseEdit={() =>{this.isEdit = false}}>
                    </Simple>
          })}
        </div>
      </blank-view>
    )
  }
}
